/**
 * @generated SignedSource<<0e82ea4f9d426fef86b6a865ec021893>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type SetFeatureFlagGlobalInput = {
  featureFlag: string;
  enabled: boolean;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type setFeatureFlagGlobalMutation$variables = {
  input: SetFeatureFlagGlobalInput;
};
export type setFeatureFlagGlobalMutation$data = {
  readonly SetFeatureFlagGlobal: {
    readonly missionControlData: {
      readonly id: string;
      readonly availableFeatures: ReadonlyArray<{
        readonly id: string;
        readonly key: string | null;
        readonly enabledForAllCompanies: boolean | null;
        readonly enabledForAllCompaniesAt: string | null;
        readonly enabledForAllCompaniesBy: string | null;
      } | null> | null;
    } | null;
  } | null;
};
export type setFeatureFlagGlobalMutation = {
  variables: setFeatureFlagGlobalMutation$variables;
  response: setFeatureFlagGlobalMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "SetFeatureFlagGlobalPayload",
    "kind": "LinkedField",
    "name": "SetFeatureFlagGlobal",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "MissionControlDataType",
        "kind": "LinkedField",
        "name": "missionControlData",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "AvailableFeaturesType",
            "kind": "LinkedField",
            "name": "availableFeatures",
            "plural": true,
            "selections": [
              (v1/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "key",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "enabledForAllCompanies",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "enabledForAllCompaniesAt",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "enabledForAllCompaniesBy",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "setFeatureFlagGlobalMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "setFeatureFlagGlobalMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "fb7daa407855156b84313ef350e545cb",
    "id": null,
    "metadata": {},
    "name": "setFeatureFlagGlobalMutation",
    "operationKind": "mutation",
    "text": "mutation setFeatureFlagGlobalMutation(\n  $input: SetFeatureFlagGlobalInput!\n) {\n  SetFeatureFlagGlobal(input: $input) {\n    missionControlData {\n      id\n      availableFeatures {\n        id\n        key\n        enabledForAllCompanies\n        enabledForAllCompaniesAt\n        enabledForAllCompaniesBy\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "8711f342f507822376c4ec12bbde2a51";

export default node;
